import { render, staticRenderFns } from "./Foreign.vue?vue&type=template&id=176dd680"
import script from "./Foreign.vue?vue&type=script&lang=js"
export * from "./Foreign.vue?vue&type=script&lang=js"
import style0 from "./Foreign.vue?vue&type=style&index=0&id=176dd680&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports